var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import IconResolverContext from './context/IconResolverContext';
import StackLayout from '../../layouts/stackLayout/StackLayoutComponent';
import useStyleObject from '../../../themes/hooks/UseStyleObject';
var IconComponent = function (props) {
    var iconResolver = useContext(IconResolverContext);
    if (!iconResolver) {
        console.error('No iconResolver provided, please add one to the ReactBaseProvider');
        return null;
    }
    var iconPropertyObject = {};
    if (props.icon) {
        iconPropertyObject[props.icon] = true;
    }
    var Icon = iconResolver(__assign(__assign({}, props), iconPropertyObject));
    var styleObject = useStyleObject(props, function (x) { return x.advancedControlsThemes.icon; }, 'margin', 'height', 'width', 'circle', 'color');
    var onPress = props.onPress;
    var iconComponent = (React.createElement(Icon, { style: __assign({}, styleObject) }));
    if (onPress) {
        return (React.createElement(StackLayout, { onPress: function (event) {
                event.preventDefault();
                event.stopPropagation();
                onPress(event);
            } }, iconComponent));
    }
    return iconComponent;
};
export default observer(IconComponent);
//# sourceMappingURL=IconComponent.js.map